<div class="h-full w-full flex flex-col gap-3 overflow-hidden bg-ds-surface" [class.p-4]="isDetached()">
  @if (isDetached()) {
    <div class="flex items-center justify-between flex-none">
      <h2 class="text-sm font-semibold font-data text-ds-text" data-testid="ocr-viewer-title">Document Viewer</h2>
      <a data-testid="ocr-viewer-back-to-history-link" [routerLink]="['/ocr-history']"
         class="text-sm text-ds-primary hover:underline inline-flex items-center gap-1 cursor-pointer transition-colors duration-150 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ds-secondary rounded-ds-sm">
        <mat-icon aria-hidden="true" class="!text-[18px] !w-[18px] !h-[18px] !leading-[18px]">arrow_back</mat-icon>
        Back to History
      </a>
    </div>
  }
  <app-resizable-container class="flex-1 min-h-0" orientation="horizontal">
    <!-- Left: Original / Markdown viewer. The header stays in embedded mode too —
         it is only a toolbar row, and dropping it would take the markdown
         toggle with it in the very view where documents get debugged. -->
    <app-document-viewer
      left
      class="block h-full overflow-hidden"
      [pdfUrl]="pdfUrl()"
      [sourceKind]="sourceKind()"
      [markdownUrl]="markdownUrl()"
      title="Document Preview" />

    <!-- Right: Details -->
    <div right class="h-full overflow-hidden">
      <div class="p-3 h-full overflow-auto">
        <app-ocr-result [metadata]="document()"></app-ocr-result>
      </div>
    </div>
  </app-resizable-container>
</div>
